import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Calendar extends DomainObject {
  calendarType;
  enabled;

  _relations = {
    calendarType: oneOf(['pto_company', 'pto_department', 'birthdays_company', 'work_anniversaries_company'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      calendarType: observable,
      enabled: observable
    });

    this.merge(other);
  }
}

export default Calendar;
